import { useEffect } from "react";

const CANONICAL_BASE = "https://westbranchmarina.com";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export const Seo = ({ title, description, path, image = "/images/hero_pontoon_golden.jpeg", jsonLd }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    const url = `${CANONICAL_BASE}${path}`;

    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", `${CANONICAL_BASE}${image}`);
    upsertMeta("property", "og:site_name", "West Branch Marina");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    const existing = document.getElementById("route-json-ld");
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "route-json-ld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, path, image, jsonLd]);

  return null;
};

export const marinaJsonLd = (loc) => ({
  "@context": "https://schema.org",
  "@type": "Marina",
  name: loc.name,
  telephone: loc.phone,
  url: `${CANONICAL_BASE}/boat-rentals/${loc.slug}`,
  image: `${CANONICAL_BASE}/images/hero_pontoon_golden.jpeg`,
  address: {
    "@type": "PostalAddress",
    streetAddress: loc.streetAddress,
    addressLocality: loc.city,
    addressRegion: loc.region,
    postalCode: loc.postalCode,
    addressCountry: "US",
  },
  containedInPlace: { "@type": "Park", name: loc.park },
});

export default Seo;
